export default{
  // API_URL: 'http://agriguru.avertastrategy.com/v1/',
  // IMG_PATH: 'http://agriguru.avertastrategy.com/v1/get-image/',
  // PDF_PATH: 'http://agriguru.avertastrategy.com/v1/getDocument/',
  // VIDEO_PATH: 'http://agriguru.avertastrategy.com/v1/get-file/'
  API_URL: 'http://15.207.18.171:8080/Agriguru/v1/',
  IMG_PATH: 'http://15.207.18.171:8080/Agriguru/v1/get-image/',
  PDF_PATH: 'http://15.207.18.171:8080/Agriguru/v1/getDocument/',
  VIDEO_PATH: 'http://15.207.18.171:8080/Agriguru/v1/get-file/'
}
